import {
  localDateTimeString,
  showToast,
  wrappedGet,
  wrappedPost,
} from "@sourcewhale/shared/src/assets/js/src/general/utils";

const uploadSpreadsheet = (data) => {
  $("#LoadingDiv").removeClass("invisible");

  wrappedPost({
    url: "/api/spreadsheet/upload",
    data: JSON.stringify(data),
    processData: false,
    contentType: false,
    success: (res) => {
      sessionStorage.setItem("fileUpload", JSON.stringify(res));
      window.location = "/options";
    },
    error: (err) => {
      if (err.status === 504)
        showToast({
          title: "Upload timed out",
          subtitle: "Please try again with a smaller spreadsheet",
          type: "danger",
        });
      else if (err.status !== 400)
        showToast({
          title: "Unable to process spreadsheet",
          subtitle: `Please try again or contact support if the issue persists<br><br>${err.responseJSON}`,
          type: "danger",
        });
      $("#LoadingDiv").addClass("invisible");
    },
  });
};

export const initializeUpload = () => {
  $("#fileUpload").change(() => {
    const fileReader = new FileReader();
    const file = $("#fileUpload").prop("files")[0];

    fileReader.onloadend = () => {
      uploadSpreadsheet({ data: fileReader.result, filename: file.name });
    };

    fileReader.readAsDataURL(file);

    $("#fileUpload").val("");
  });

  wrappedGet({
    url: "/api/spreadsheet/get_recent",
    success: (res) => {
      if (res.length) $("#recentUploadsContainer").show();
      res.forEach((item) => {
        const dt = localDateTimeString(item.timestamp);
        const imgUrl = item.filename.endsWith("xlsx") ? "xlsx.png" : "csv.png";
        $("#recentUploadsDiv").append(`
            <div class="recentUploadItem d-flex align-items-center flex-column mb-5">
              <img src="/assets/img/upload/${imgUrl}" style="width:3rem" class="mb-3">
              ${dt}
              <br>
              ${item.filename}
            </div>
          `);
      });
    },
  });
};
